module.exports = __webpack_public_path__ + "static/mccarthy-hall-5-thumb-5e97be18239b8c3c5242cabff14c07a5.jpg";